
export const filterValueNice = (filterValue) => {
    if (filterValue === "all") {
        return "All";
    } else if (filterValue === "unread") {
        return "Unread";
    } else if (filterValue === "reading") {
        return "Reading";
    } else if (filterValue === "completed") {
        return "Completed";
    }
}

export const filterRatingValueNice = (filterRatingValue) => {
    if (filterRatingValue === 0) {
        return "All";
    } else if (filterRatingValue === 1) {
        return "1 Star";
    } else if (filterRatingValue === 2) {
        return "2 Stars";
    } else if (filterRatingValue === 3) {
        return "3 Stars";
    } else if (filterRatingValue === 4) {
        return "4 Stars";
    } else if (filterRatingValue === 5) {
        return "5 Stars";
    }
}

export const sortValueNice = (sortValue) => {
    if (sortValue === "title asc") {
        return "Title A - Z";
    } else if (sortValue === "title desc") {
        return "Title Z - A";
    } else if (sortValue === "date asc") {
        return "Added Old to New";
    } else if (sortValue === "date desc") {
        return "Added New to Old";
    } else if (sortValue === "published asc") {
        return "Published Old to New";
    } else if (sortValue === "published desc") {
        return "Published New to Old";
    } else if (sortValue === "read asc") {
        return "Read Old to New";
    } else if (sortValue === "read desc") {
        return "Read New to Old";
    }
}